// Reusable V2 section panel: a blue rounded header bar with an outlined body
// below it. Used by the "What changed?" board and the Credit Card section so
// they share identical styling.

import React from "react";
import { Box, Paper, Typography } from "@mui/material";

interface ISectionPanelProps {
  heading: string;
  rightText?: string;
  // Optional element rendered on the right of the blue header (e.g. an add button).
  headerAction?: React.ReactNode;
  children: React.ReactNode;
  bodySx?: object;
  sx?: object;
}

export const SectionPanel: React.FC<ISectionPanelProps> = ({
  heading,
  rightText,
  headerAction,
  children,
  bodySx,
  sx,
}) => {
  return (
    <Box sx={sx}>
      {/* Blue header bar */}
      <Box
        sx={{
          backgroundColor: "primary.main",
          color: "#fff",
          borderTopLeftRadius: 6,
          borderTopRightRadius: 6,
          px: 3,
          py: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="subtitle1" fontWeight={700}>
          {heading}
        </Typography>
        {headerAction
          ? headerAction
          : rightText && (
              <Typography variant="body2" sx={{ opacity: 0.85 }}>
                {rightText}
              </Typography>
            )}
      </Box>

      {/* Outlined body */}
      <Paper
        variant="outlined"
        sx={{
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          p: 2,
          ...bodySx,
        }}
      >
        {children}
      </Paper>
    </Box>
  );
};
